// extracted by mini-css-extract-plugin
module.exports = {"arrow_functionality":"Arrow_arrow_functionality__Rvp4f","disabled_icon":"Arrow_disabled_icon__ogM6I"};